import { useContext } from "react";

import { Col, Row } from "antd";
import { AppContext } from "App";
import SignUpForm from "components/basic/SignUpForm/SignUpForm";

const SignUpSection = () => {
    const {
        isMobile,
        maxWidth,
        formScale,
        isAuth,
    } = useContext(AppContext);

    return (
        <div className='horizontal-center' style={{ maxWidth: "100vw", backgroundColor: "#F7F7F7" }}>
            <div className='horizontal-center' style={{ maxWidth: maxWidth, padding: isMobile ? "20px" : "64px 100px", overflow: isMobile ? "hidden" : "" }}>
                <Row gutter={[64, { xs: 32, sm: 32, md: 72, lg: 72 }]} >
                    <Col sm={24} xs={24} md={24} lg={14} xl={14}>
                        <div>
                            <div className={"section-title"}>
                                Are you ready to get your refund now?
                            </div>

                            <div className={"mt30 mb20"} style={{ maxWidth: "300px" }}>
                                Your tax return has never been easier! Sign up now and begin your journey with TaxZap!
                            </div>

                            <button className="shared__primary-button">Sign Up</button>
                        </div>
                    </Col>
                    <Col md={24} lg={10} xl={10} className="horizontal-right">

                        {!isMobile && (
                            <div
                                style={{
                                    transform: `scale(${formScale})`,
                                    transition: "transform 0.2s ease-in-out",
                                    ...(isAuth && {
                                        pointerEvents: "none",
                                        opacity: 0.5,
                                        filter: "grayscale(100%)",
                                    }),
                                }}
                            >
                                <div className="sign-up-section__form">
                                    <SignUpForm/>
                                </div>
                            </div>
                        )}

                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default SignUpSection;
